import { User } from "@/types/user";
import { UseMutationResult } from "@tanstack/react-query";
import { createContext } from "react";
import { Resource, AccessLevel } from "@/types/user";

interface LoginResponse {
    access: string;
    refresh: string;
    user: LoginUser;
}

interface LoginUser {
    pk: number;
    email: string;
    username: string;
    first_name: string;
    last_name: string;
}

type AuthContextType = {
    user?: User;
    signIn: (data: { username: string; password: string }) => void;
    logout: () => void;
    refreshUser: () => void;
    isSuccess: boolean;
    isError: boolean;
    isPending: boolean;
    isFetched: boolean;
    signInMutate: UseMutationResult<
        LoginResponse,
        Error,
        {
            username: string;
            password: string;
        },
        unknown
    >;
    userIsSentinel: boolean;
    isConsultantOrSentinel: boolean;
    isConsultant: boolean;
    isGrower: boolean;
    runStartup: () => void;
    accessControl?: Record<Resource, AccessLevel>;
    isAtLeastSummary: (resource: Resource) => boolean;
    isAtLeastDetail: (resource: Resource) => boolean;
    isAtLeastSentinel: (resource: Resource) => boolean;
    forcedLevel: AccessLevel | null;
    setForcedLevel: (level: AccessLevel | null) => void;
    actionRequired: boolean;
};

const AuthContext = createContext<AuthContextType | null>(null);

export default AuthContext;
export type { AuthContextType };
